const FileTextIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
    </svg>
);

const ArrowLeftIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="19" y1="12" x2="5" y2="12" /><polyline points="12 19 5 12 12 5" />
    </svg>
);

const TermsPage = ({ attributes, onBack }) => {
    const { termsPage = {}, primaryColor = '#ff0037' } = attributes;
    const {
        showHeader = true,
        headerText = 'Legal',
        title = 'Terms & Conditions',
        description = '',
        showBackButton = true,
        backButtonText = 'Back to Home',
    } = termsPage;

    return (
        <div className="gmf-privacy-page-wrapper">
            <div className="gmf-privacy-page-container">
                <div className="gmf-privacy-page-breadcrumb">
                    <span className="gmf-privacy-page-breadcrumb-home" onClick={onBack}>Home</span>
                    <span className="gmf-privacy-page-breadcrumb-sep">/</span>
                    <span className="gmf-privacy-page-breadcrumb-current">{title}</span>
                </div>

                {showHeader && (
                    <div className="gmf-privacy-page-header">
                        <div className="gmf-privacy-page-header-icon-wrap" style={{ background: `linear-gradient(135deg, ${primaryColor}22, ${primaryColor}44)` }}>
                            <span style={{ color: primaryColor }}><FileTextIcon /></span>
                        </div>
                        {headerText && <span className="gmf-privacy-page-header-label" style={{ color: primaryColor }}>{headerText}</span>}
                        <h1 className="gmf-privacy-page-title">{title}</h1>
                        {description && <p className="gmf-privacy-page-description">{description}</p>}
                    </div>
                )}

                {/* {Array.isArray(sections) && sections.length > 0 ? (
                    <div className="gmf-privacy-sections">
                        {sections.map((section, index) => (
                            <div key={section.id || index} className="gmf-privacy-section-card">
                                <div className="gmf-privacy-section-header">
                                    <h2 className="gmf-privacy-section-title">{section.title}</h2>
                                </div>
                                <div className="gmf-privacy-section-content">
                                    {(section.content || '').split('\n').filter(Boolean).map((line, i) => (
                                        <p key={i}>{line}</p>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="gmf-privacy-empty">
                        <FileTextIcon />
                        <p>No terms sections configured. Please add sections in the settings.</p>
                    </div>
                )} */}

                {showBackButton && (
                    <div className="gmf-privacy-page-back">
                        <button className="gmf-privacy-page-back-btn" onClick={onBack} style={{ backgroundColor: primaryColor }}>
                            <ArrowLeftIcon />
                            {backButtonText}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default TermsPage;
